import { jsx, jsxs } from "react/jsx-runtime";
import { memo, forwardRef } from "react";
import { IconBase } from "src/components/ui/IconBase";
export default memo(forwardRef(function IconSvgMapPointA({
  className,
  "data-test-id": dataTest = "IconMapPointA",
  ...props
}, ref) {
  return /* @__PURE__ */ jsx(IconBase, { ...props, "data-test-id": dataTest, className, innerRef: ref, children: /* @__PURE__ */ jsxs("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.95227 16H9.63977L10.3615 13.848H13.6426L14.3656 16H16.0531L12.9764 7.27271H11.0247L7.95227 16ZM13.2159 12.5781L12.0347 9.06248H11.9665L10.7874 12.5781H13.2159Z", fill: "currentColor" }),
    /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12ZM12 20C7.64266 20 4 16.3573 4 12C4 7.64267 7.64267 4 12 4C16.3573 4 20 7.64266 20 12C20 16.3573 16.3573 20 12 20Z", fill: "currentColor" })
  ] }) });
}));
